import * as types from "./constants";

export function getNavigationConfig({ getNavigationConfigApi }) {
    return {
      type: types.GET_NAVIGATION_CONFIG_REQUEST,
      getNavigationConfigApi,
    };
  }
  